import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { Director } from "@/components/site/Director";
import { CurrentProject } from "@/components/site/CurrentProject";
import { Upcoming } from "@/components/site/Upcoming";
import { Portfolio } from "@/components/site/Portfolio";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

const LandingPage = () => {
  return (
    <main className="min-h-screen bg-[#050505] text-white relative" data-testid="landing-page">
      <Navbar />
      <Hero />
      <About />
      <Director />
      <CurrentProject />
      <Upcoming />
      <Portfolio />
      <Contact />
      <Footer />
    </main>
  );
};

export default LandingPage;
